import { Klydo } from "../context/klydo/KlydoTypes";
import { GreetingTone } from "../themes-views/Gifts/GenerateGreet/components/ToneSelector";
import { baseClient } from "./baseRequest";

export type Gift = {
  giftId: string;
  orderName: string;
  timeZone?: string;
  klydoId: string;
  senderName?: string;
  date?: number;
  senderImageUrl?: string;
  greetingContent?: string;
  pendulumLogoUrl?: string;
  giftTerms?: {
    accepted: boolean;
    signedTimestamp: number | null;
  };
};
export type KlydosGift = {
  category: string;
  klydos: Klydo[];
};

export type PopulatedGift = Gift & {
  klydo: Klydo;
};

export type GiftInformation = {
  gift?: PopulatedGift;
  clockInfo?: {
    id?: string;
    idf?: string;
    registerProduct?: boolean;
  };
};

export type KlydoGiftProps = Gift & {
  clockId: string;
};

export type GiftCategory = {
  name: string;
  categoryImageUrl: string;
  klydoIds: string[];
  klydos: Klydo[];
  pendulumLogoUrl?: string;
};

export type GenerateGreetPayload = {
  recipientName: string;
  eventDescription: string;
  tone?: GreetingTone;
};

export type GiftClient = {
  upsertGift: (input: KlydoGiftProps) => Promise<void>;
  listCategories: () => Promise<GiftCategory[]>;
  generateGreet(generateGreetPayload: GenerateGreetPayload): Promise<string>;
  getGift(params: {
    clockId?: string;
    clockIdf?: string;
    orderName?: string;
  }): Promise<GiftInformation>;
};

const giftClient: GiftClient = {
  upsertGift: async (input) => {
    return baseClient.put({
      url: "/gift",
      body: input,
    });
  },
  listCategories: async () => {
    return baseClient.get({
      url: "/gift-categories",
    });
  },
  generateGreet: async (generateGreetPayload) => {
    return baseClient.post({
      url: "/gift/generate-greet",
      body: generateGreetPayload,
    });
  },
  getGift: async (params) => {
    const queryParams = new URLSearchParams();
    if (params.clockId) queryParams.set("clock-id", params.clockId);
    if (params.clockIdf) queryParams.set("clock-idf", params.clockIdf);
    if (params.orderName) queryParams.set("order-name", params.orderName);

    return baseClient.get({
      url: `/gift?${queryParams.toString()}`,
    });
  },
};

export default giftClient;
